import { QueueState } from './Interfaces/QueueState';

const queueConfigurationInitialState: QueueState = {
    configuration: null,
};

export default queueConfigurationInitialState;
